<template>
  <div class="entity-form">
    <v-container
      id="fcreate"
      fluid
    >
      <breadcrumbs />
      <h1 class="mb-2">
        Новый промокод
      </h1>

      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
      >
        <v-row>
          <v-col
            cols="12"
            md="7"
          >
            <v-card>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <!-- Название -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.name"
                        label="Название"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Описание -->
                    <v-col cols="12">
                      <v-textarea
                        v-model="data.description"
                        :counter="300"
                        label="Описание"
                        outlined
                        :rules="rules.description"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Код -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.code"
                        label="Код"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Тип -->
                    <v-col cols="12">
                      <v-select
                        v-model="data.type"
                        label="Тип"
                        :items="[
                          { name: 'Для всех', val: 'all' },
                          { name: 'Персональная скидка', val: 'personal' },
                        ]"
                        item-text="name"
                        item-value="val"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Действие -->
                    <v-col cols="12">
                      <v-select
                        v-model="data.action"
                        label="Действие"
                        :items="[
                          { name: 'Блюдо в подарок', val: 'dishGift' },
                          { name: 'Удвоение заказа', val: 'doubling' },
                          { name: 'Удвоение 2.0', val: 'doubling_marked' },
                          { name: 'Скидка в рублях', val: 'subtract' },
                          { name: 'Скидка в процентах', val: 'percent' },
                          { name: 'День рождения', val: 'birthDay' },
                        ]"
                        item-text="name"
                        item-value="val"
                        outlined
                        required
                        :rules="rules.required"
                        :loading="loading"
                        :disabled="loading"
                        @change="resetActionSettings"
                      />
                    </v-col>
                    <!-- Процент скидки -->
                    <v-col
                      v-if="['percent', 'birthDay'].includes(data.action)"
                      cols="12"
                    >
                      <v-text-field
                        v-model="data.salePercent"
                        label="Процент скидки"
                        outlined
                        :rules="rules.requiredNumber"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Сумма скидки -->
                    <v-col
                      v-if="data.action === 'subtract'"
                      cols="12"
                    >
                      <v-text-field
                        v-model="data.saleSubtraction"
                        label="Сумма скидки"
                        outlined
                        :rules="rules.requiredNumber"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!-- Товар по акции -->
                    <v-col
                      v-if="data.action === 'dishGift'"
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="data.saleMenuItemId"
                        :items="getMenuItems"
                        item-text="name"
                        item-value="id"
                        label="Товар по акции"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Модификация товара по акции -->
                    <v-col
                      v-if="data.action === 'dishGift'"
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="data.saleModificationMenuItemId"
                        :items="getChangedMenuItemModifications"
                        item-text="modification.name"
                        item-value="id"
                        label="Модификация товара по акции"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!--Доступно в регионах-->
                    <v-col cols="12">
                      <regions-select-fields
                        v-model="data.regions"
                        label="Доступно в регионах"
                        empty-text="Доступно во всех регионах"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <v-col cols="12">
                      <regions-select-fields
                        v-model="data.regionsExclude"
                        label="Не доступно в регионах"
                        empty-text="Нет исключенных регионов"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <v-col cols="12">
                      <categories-select-fields
                        v-model="data.allowedCategories"
                        label="Доступно для блюд из категорий"
                        empty-text="Для всех категорий"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <v-col cols="12">
                      <menu-items-select-fields
                        v-model="data.allowedMenuItems"
                        label="Доступно для отдельных блюд"
                        empty-text="Для всех блюд"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!-- Дата начала -->
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="8">
                          <!-- ДАТА -->
                          <v-menu
                            v-model="data.timeOn.menu"
                            :close-on-content-click="false"
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="computedTimeOnDateFormattedMomentjs"
                                label="Дата начала"
                                v-bind="attrs"
                                readonly
                                outlined
                                clearable
                                v-on="on"
                                @click:clear="data.timeOn.date = null"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.timeOn.date"
                              @change="data.timeOn.menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <!-- ВРЕМЯ -->
                        <v-col cols="4">
                          <v-menu
                            ref="menuTimeOnTime"
                            v-model="data.timeOn.menuTime"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="data.timeOn.time"
                                label="Время начала"
                                prepend-icon="mdi-clock-time-four-outline"
                                v-bind="attrs"
                                readonly
                                outlined
                                clearable
                                v-on="on"
                                @click:clear="data.timeOn.time = null"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="data.timeOn.menuTime"
                              v-model="data.timeOn.time"
                              format="24hr"
                              @click:minute="$refs.menuTimeOnTime.save(data.timeOn.menuTime)"
                            ></v-time-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- Дата конца -->
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="8">
                          <!-- ДАТА -->
                          <v-menu
                            v-model="data.timeEnd.menu"
                            :close-on-content-click="false"
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="computedTimeEndDateFormattedMomentjs"
                                clearable
                                label="Дата конца"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="data.timeEnd.date = null"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="data.timeEnd.date"
                              @change="data.timeEnd.menu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <!-- ВРЕМЯ -->
                        <v-col cols="4">
                          <v-menu
                            ref="menuTimeEndTime"
                            v-model="data.timeEnd.menuTime"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="data.timeEnd.time"
                                clearable
                                label="Время начала"
                                prepend-icon="mdi-clock-time-four-outline"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="data.timeEnd.time = null"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                              v-if="data.timeEnd.menuTime"
                              v-model="data.timeEnd.time"
                              format="24hr"
                              @click:minute="$refs.menuTimeEndTime.save(data.timeEnd.menuTime)"
                            ></v-time-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-row>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <enum-value-select-field
                            v-model="data.dayOfWeekBegin"
                            label="Доступен с (день недели, включительно)"
                            :enum-class="getDayOfWeekEnumClass()"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>

                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <enum-value-select-field
                            v-model="data.dayOfWeekEnd"
                            label="Доступен до (день недели, включительно)"
                            :enum-class="getDayOfWeekEnumClass()"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12">
                      <v-row>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <time-picker-field
                            v-model="data.timeAvailableFrom"
                            label="Доступен с (ч:м)"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>
                        <v-col
                          cols="6"
                          sm="12"
                          md="6"
                        >
                          <time-picker-field
                            v-model="data.timeAvailableTo"
                            label="Доступен до (ч:м)"
                            :loading="loading"
                            :disabled="loading"
                          />
                        </v-col>
                      </v-row>
                    </v-col>

                    <!-- Минимальная сумма заказа -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.minTotalPriceRub"
                        label="Минимальная сумма заказа, руб."
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.minTotalPriceSelfRub"
                        label="Минимальная сумма заказа для самовывоза, руб."
                        outlined
                        :loading="loading"
                        :disabled="loading"
                        hint="Если не заполнена, то берется число из поля выше"
                      />
                    </v-col>
                    <v-col cols="12">
                      <enum-value-select-field
                        v-model="data.deliveryType"
                        label="Доступен только для следующего метода доставки"
                        :enum-class="getPromocodeDeliveryClassEnum()"
                        :loading="loading"
                        :disabled="loading"
                        hint="Если не заполнено, доступен для любого"
                      />
                    </v-col>

                    <v-col cols="12">
                      <enum-value-multi-select-field
                        v-model="data.allowedClientDeviceTypes"
                        label="Доступен для источников заказа"
                        :enum-class="getClientDeviceTypeClassEnum()"
                        :loading="loading"
                        :disabled="loading"
                        empty-text="Если не заполнено, доступен для любого"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.onlyFirstOrderOfDeviceTypes"
                        label="Только на первый заказ из выбранных источников"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>

                    <!-- Показывать в меню -->
                    <v-col
                      v-show="false"
                      cols="12"
                    >
                      <v-checkbox
                        v-model="data.showMenu"
                        label="Показывать в меню"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Только для новых покупателей -->
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.onlyFirstOrder"
                        label="Только для новых покупателей"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.repeat"
                        label="Разрешить повторное применение промокода клиентом"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.onlyCrm"
                        label="Разрешить применять только из CRM"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        v-model="data.status"
                        label="Промокод активен"
                        outlined
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Сортировка -->
                    <v-col cols="12">
                      <v-text-field
                        v-model="data.sortOrder"
                        label="Сортировка"
                        outlined
                        required
                        :rules="rules.requiredNumber"
                        :loading="loading"
                        :disabled="loading"
                      />
                    </v-col>
                    <!-- Submit -->
                    <v-col cols="12">
                      <v-row>
                        <v-col>
                          <v-btn
                            block
                            class="mb-2"
                            large
                            color="success"
                            :loading="loading"
                            :disabled="loading"
                            type="submit"
                          >
                            Создать
                          </v-btn>
                        </v-col>
                        <v-col>
                          <v-btn
                            block
                            large
                            color="primary"
                            :loading="loading"
                            :disabled="loading"
                            @click.prevent="$router.push('/promocodes')"
                          >
                            Отмена
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-snackbar v-model="snackbar">
        Исправьте ошибки и повторите попытку
        <template v-slot:action="{ attrs }">
          <v-btn
            color="red"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import rules from '@/mixins/rules'
  import RegionsSelectFields from '@/components/ui/crud/fields/RegionsSelectField.vue'
  import TimePickerField from '@/components/ui/crud/fields/TimePickerField.vue'
  import EnumValueSelectField from '@/components/ui/crud/fields/EnumValueSelectField.vue'
  import DayOfWeek from '@/models/enums/DayOfWeek'
  import DeliveryType from '@/models/enums/DeliveryType'
  import MenuItemsSelectFields from '@/components/ui/crud/fields/MenuItemsSelectField.vue'
  import CategoriesSelectFields from '@/components/ui/crud/fields/CategoriesSelectField.vue'
  import EnumValueMultiSelectField from '@/components/ui/crud/fields/EnumValueMultiSelectField.vue'
  import ClientDeviceType from '@/models/enums/ClientDeviceType'

  export default {
    components: {
      EnumValueMultiSelectField,
      CategoriesSelectFields,
      MenuItemsSelectFields,
      EnumValueSelectField,
      TimePickerField,
      RegionsSelectFields,
    },
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          description: '',
          code: '',
          type: 'all',
          action: 'dishGift',
          salePercent: '',
          saleSubtraction: '',
          timeOn: {
            menu: false,
            menuTime: false,
            date: '',
            time: '',
          },
          timeEnd: {
            menu: false,
            menuTime: false,
            date: '',
            time: '',
          },
          timeAvailableFrom: null,
          timeAvailableTo: null,
          dayOfWeekBegin: null,
          dayOfWeekEnd: null,
          showMenu: '',
          saleMenuItemId: null,
          saleModificationMenuItemId: null,
          minTotalPriceRub: null,
          minTotalPriceSelfRub: null,
          onlyFirstOrder: false,
          allowedClientDeviceTypes: null,
          onlyFirstOrderOfDeviceTypes: false,
          sortOrder: 0,
          status: true,
          regions: [],
          regionsExclude: [],
          repeat: true,
          deliveryType: null,
          allowedCategories: [],
          allowedMenuItems: [],
        },
        valid: false,
        loading: false,
        snackbar: false,
      }
    },
    computed: {
      ...mapGetters({
        getMenuItems: 'menuItems/getMenuItemsList',
      }),
      computedTimeOnDateFormattedMomentjs () {
        return this.data.timeOn.date ? moment(this.data.timeOn.date).format('YYYY-MM-DD') : ''
      },
      computedTimeEndDateFormattedMomentjs () {
        return this.data.timeEnd.date ? moment(this.data.timeEnd.date).format('YYYY-MM-DD') : ''
      },
      getChangedMenuItemModifications () {
        return this.data.saleMenuItemId
          ? this.getMenuItems.find(v => v.id === this.data.saleMenuItemId).modifications
          : []
      },
    },
    async created () {
      await this.$store.dispatch('menuItems/fetchMenuItemsList', {
        limit: 10000,
        offset: 0,
        page: 0,
      })
    },
    methods: {
      getDayOfWeekEnumClass () {
        return DayOfWeek
      },
      getPromocodeDeliveryClassEnum () {
        return DeliveryType
      },
      getClientDeviceTypeClassEnum () {
        return ClientDeviceType
      },
      async submit () {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loading = true

          try {
            const data = this.data
            /**
             * Меняем дату время на UNIXTIME
             */
            const timeOn = `${ data.timeOn.date }T${ data.timeOn.time }`
            const timeEnd = `${ data.timeEnd.date }T${ data.timeEnd.time }`
            data.timeOn = moment(timeOn).unix()
            data.timeEnd = moment(timeEnd).unix()

            switch (data.action) {
              case 'dishGift' || 'doubling':
                data.salePercent = null
                data.saleSubtraction = null
                break
              case 'subtract':
                data.salePercent = null
                break
              case 'percent':
                data.saleSubtraction = null
                break
              default:
                break
            }

            const res = await this.$store.dispatch('promocodes/createPromocodes', data)
            if (res.status === 200) {
              this.$router.push('/promocodes')
            }
          } catch (e) { console.log(e) }

          this.loading = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
      resetActionSettings () {
        this.data.salePercent = null
        this.data.saleSubtraction = null
      },
    },
  }
</script>
